webpackJsonp([36],{

/***/ "m5ZQ":
/***/ (function(module, exports, __webpack_require__) {

var mariSmithTutorials = (function () {
    function mariSmithTutorials() {
    }
    return mariSmithTutorials;
}());
angular.module('animatronApp.wave.mariSmithTutorials', []).component('mariSmithTutorials', {
    controller: mariSmithTutorials,
    templateUrl: __webpack_require__("wL/W")
});


/***/ }),

/***/ "wL/W":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/mari-smith-tutorials_397c71b95b41cf647b60291b37f7f5c1.html";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/36-bd880478516a225297ea.min.js